import { render } from "./squashSetting.vue?vue&type=template&id=cc2009e8&scoped=true"
import script from "./squashSetting.vue?vue&type=script&lang=js"
export * from "./squashSetting.vue?vue&type=script&lang=js"

import "./squashSetting.vue?vue&type=style&index=0&id=cc2009e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc2009e8"]])

export default __exports__